import React, { useState } from 'react';
import { IonContent, IonPage, IonSearchbar, IonList } from '@ionic/react';
import removeAccents from 'remove-accents';
import AppHeader from '../components/AppHeader';
import AccordionItem, { AccordionItemProps } from '../components/AccordionItem';
import './Faq.scss';

const Faq: React.FC = () => {
  const [searchText, setSearchText] = useState('');
  const searchTextArray = removeAccents(searchText).toLowerCase().split(' ');

  const faqs: Array<AccordionItemProps> = [
    {
      name: 'Les documents à apporter au laboratoire',
      content:
        '<ul><li>L’ordonnance de votre médecin. Les analyses sans ordonnance sont possibles mais facturées directement</li><li>Votre carte vitale à jour ou attestation en cours de validité. Dans le cas où votre carte vitale ne serait pas à jour, nos laboratoires disposent d’une borne d’activation</li><li>Votre carte mutuelle en cours de validité couvrant les analyses</li><li>Un document justifiant de votre identité (pour une question d’identitovigilance)</li></ul>'
    },
    {
      name: 'Puis-je faire un examen sans ordonnance ?',
      content:
        '<p>La plupart des examens peuvent être réalisés sans ordonnance. Il vous sera demandé de remplir et signer un formulaire de consentement indiquant votre demande.</p><p>Veuillez noter que ces examens vous seront facturés directement car ils ne seront pas pris en charge ni par l’assurance maladie ni par votre mutuelle.</p>'
    },
    {
      name: 'Puis-je demander un prélèvement à domicile ?',
      content:
        '<p>Si votre médecin estime que la prise de sang doit être réalisée à domicile, il indiquera sur l’ordonnance la mention « à domicile ». En l’absence de cette mention, le déplacement à domicile ne pourra pas être couvert par la sécurité sociale et restera à votre charge.</p><p>Si vous souhaitez le prélèvement à domicile, veuillez l’indiquer lors de la prise de créneau de prise en charge.</p>'
    },
    {
      name: 'Récupérer mes résultats d’analyses',
      content:
        '<p>Le délai d’obtention de vos résultats dépend des examens à effectuer. Il vous sera communiqué au moment de l’enregistrement de votre dossier en laboratoire ou lors de votre prélèvement.</p><p>Vous recevrez une notification via cette application lorsque les résultats vous seront transmis. Vos résultats sont accessibles dans la rubrique "Vos résultats" (du site Internet et non de l\'app Le Pass).</p><p>N’hésitez pas à contacter votre laboratoire UNILABS si vous avez de plus amples questions à ce sujet.</p>'
    },
    {
      name: 'Comment dois-je me préparer avant ma venue au laboratoire ?',
      content:
        '<p>Certains tests nécessitent d’être à jeun : cholestérol, bilan lipidique, glycémie, HGPO, test d’O’Sullivan, test HELIKIT, insuliménie.</p><p>Il est préférable de réaliser sa prise de sang à distance d’un repas quel que soit le paramètre à doser. Il est également contre-indiqué de fumer avant le prélèvement car ceci peut modifier la concentration de certains paramètres biologiques.</p><p>Si votre examen nécessite d’être à jeun strict ou non strict, veuillez accéder à la rubrique « Dois-je venir à jeun ? »</p><p>Si vous êtes sous traitement médicamenteux, merci de le signaler lors de votre enregistrement.</p><p>Dans le cas où votre examen permet de doser un médicament lui-même, le dosage de la plupart des médicaments par voie orale s’effectue juste avant la prise médicamenteuse, c’est-à-dire « en résiduel ». En revanche, le prélèvement doit être effectué dans les plus brefs délais en cas de soupçons de surdosage ou d’intoxication.</p>'
    },
    {
      name: 'Dois-je venir à jeûn ?',
      content:
        '<p>Jeûne non strict : Nous considérons le jeûne « non strict » comme une période de 10 à 12h après votre dernier repas. Vous pourrez boire un verre d’eau et vous brosser les dents.</p><p>Jeûne strict : Vous NE pouvez PAS boire un verre d’eau, ni vous brosser les dents, ni fumer.</p><p>Si vous travaillez de nuit ou que vous pratiquez le ramadan, il convient d’adapter les horaires de prélèvement par rapport au dernier repas.</p>'
    }
  ];

  return (
    <IonPage>
      <AppHeader />
      <IonContent>
        <div className="wrapper wrapper--large ion-padding-vertical">
          <div className="ion-padding-horizontal">
            <h2>Préparez votre venue au laboratoire</h2>
          </div>
          <IonSearchbar
            value={searchText}
            onIonChange={(e) => setSearchText(e.detail.value!)}
            placeholder="Rechercher"
            onKeyUp={(e) => {
              if (e.which === 13) {
                (e.target as HTMLInputElement).blur();
              }
            }}
          ></IonSearchbar>
          <IonList className="ion-text-content ion-padding faq-list">
            {faqs
              .filter((faq) =>
                searchTextArray
                  .map((word: string) => removeAccents(faq.name).includes(word))
                  .includes(true)
              )
              .map((faq) => (
                <div className="faq-accordion-item-wrapper" key={faq.name}>
                  <AccordionItem {...faq} key={faq.name} />
                </div>
              ))}
          </IonList>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Faq;
